import { render, staticRenderFns } from "./SocialChatMembersPage.vue?vue&type=template&id=e245756a&scoped=true"
import script from "./SocialChatMembersPage.vue?vue&type=script&lang=js"
export * from "./SocialChatMembersPage.vue?vue&type=script&lang=js"
import style0 from "./SocialChatMembersPage.vue?vue&type=style&index=0&id=e245756a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e245756a",
  null
  
)

export default component.exports